// extracted by mini-css-extract-plugin
export default {"main":"Contact_main__J2d-b","mian_2":"Contact_mian_2__Ng3AI","arrow":"Contact_arrow__q9ee7","spacing":"Contact_spacing__t7+8e"};